import Errors from './StandardErrors'

export default class CustomHomelabErrors extends Errors {
  record (errors, prefix = '') {
    let auxErrors = {}

    errors.forEach(element => {
      let tempError = prefix + element.messages[0].toLowerCase().replace(/ /g, '_')
      if (tempError[tempError.length - 1] === '.') {
        tempError = tempError.substr(0, tempError.length - 1)
      }
      auxErrors[element.field] = tempError
    })

    this.errors = auxErrors
  }
  set (field, error) {
    let errors = { ...this.errors }
    errors[field] = []
    errors[field].push(error)
    this.errors = errors
  }
}
